import { createCustomEnum } from "./customEnum";

export type PaymentTypesType = "none" | "ach" | "credit_card";

const PaymentTypes = createCustomEnum({
	none: {
		value: 0,
		name: "none",
		displayName: "None",
	},
	ach: {
		value: 1,
		name: "ach",
		displayName: "ACH",
	},
	creditCard: {
		value: 2,
		name: "credit_card",
		displayName: "Credit Card",
	},
});

export default PaymentTypes;
